export default __webpack_public_path__ + "static/media/verify_email.38352e9e.jpg";